// Shared by the CE rule and Oak so the two can't drift.
export function reviewerHasAccessToAllFacilities(args: {
  userFacilityIds: string[];
  submissionFacilityIds: string[];
  isStaff: boolean;
  hasAllFacilityAccess: boolean;
}): boolean {
  const { userFacilityIds, submissionFacilityIds, isStaff, hasAllFacilityAccess } = args;
  if (isStaff || hasAllFacilityAccess) return true;

  const requiredFacilityIds = submissionFacilityIds.filter((id) => id && id.trim() !== "");
  if (requiredFacilityIds.length === 0) return true;

  const accessibleIds = new Set(userFacilityIds.filter((id) => id && id.trim() !== ""));
  return requiredFacilityIds.every((facilityId) => accessibleIds.has(facilityId));
}
